<!--NOTE: f1118-schd-c component is common for CDE schedules, making changes here will affect all the CDE schedules.
Incase adhoc feature is required for E or any change of requirement in C/D, consider spinning a new component for the schd-->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{panelHeader}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="modalClose()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

@if (isModalLoading) {
<mat-progress-bar
  color="primary"
  mode="indeterminate">
</mat-progress-bar>
}
@if (!isModalLoading) {
<div class="modal-body no-body-scroll" [hidden]="minimise">
    <div class="divShadow1">
            <div style="border:none;">
                <table class="table table-striped blue" style="text-align: left; width: 100%;" >
                    <thead>
                        <tr>
                            <th colspan="11" style="text-align: center;">{{panelHeader}}</th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr>
                                <td colspan = 1>Basket:</td>
                                <td colspan = 1>
                                    <select class="basket-select"
                                            [ngModel]="selectedBasketId"
                                            (ngModelChange)="onBasketChange($event)"
                                            [disabled]="!isCustomOverrideWindow">
                                        <option [ngValue]="0" disabled>Select Basket</option>
                                        @for (item of basketList; track $index) {
<option [ngValue]="item.value">{{item.label}}</option>
}
                                    </select>
                                </td>
                                <td colspan=8></td>
                            </tr>
                            @for (trItem of [].constructor((noOfFields/fieldsPerRow)+1); track $index; let trIndex = $index) {
<tr  style=" border: 1px solid #ddd;padding: 4px; ">
                            <!-- <tr  *ngFor="let item of lineColDtls.jsonObject; let i = index;" style=" border: 1px solid #ddd;padding: 4px; background-color: white;"> -->
                                    @for (item of lineColDtls | slice:(trIndex * fieldsPerRow) : (trIndex * fieldsPerRow)+fieldsPerRow; track $index; let i = $index) {

                                        <td>{{item.COL_LINE_DESC}}</td>
                                        <td>
                                            <!-- <label>{{item.COL_LINE_DESC}}</label>&nbsp;&nbsp; -->
                                            @if (item.IS_AMT == '1') {
<div>
                                                <input type = "number" [(ngModel)]="item.ELEMENT_VALUE" [disabled]="item.IS_READ_ONLY || isViewOnly"
                                                style="text-align: right !important;" (change) = "getTestData();">
                                            </div>
}
                                            @if (item.IS_AMT == '0') {
<div>
                                                <input type = "text" [(ngModel)]="item.ELEMENT_VALUE" [disabled]="item.IS_READ_ONLY || isViewOnly"
                                                    style="text-align: right !important;" (change) = "getTestData();">
                                            </div>
}
                                        </td>
                                    
}
                            </tr>
}
                    </tbody>
                </table>
            </div>
   </div>
    <div>
        @if (isCustomOverrideWindow && isEdit) {
<div style="float: left;">
            <ap-button [btnType]="'primary'" [label]="'Delete'" class="ap-mr-spacing-3" (onClick)="deleteData(0)"></ap-button>
        </div>
}
        <div style="float: right; display: flex; justify-content: flex-end;">
            <ap-button [btnType]="'primary'" [label]="'Save'" class="ap-mr-spacing-3" [disabled]="isViewOnly" (onClick)="saveData()"></ap-button>
            @if (!isCustomOverrideWindow) {
<ap-button [btnType]="'primary'" [label]="'Reset'" class="ap-mr-spacing-3" (onClick)="onResetClick()"></ap-button>
}
            <ap-button [btnType]="'primary'" [label]="'Cancel'" class="ap-mr-spacing-3" (onClick)="modalClose()"></ap-button>
        </div>
    </div>
    <div style="display:block;height: 26px;"></div>

    <!-- <mat-progress-bar *ngIf = "!tableLoadingData"
    color="primary"
    mode="indeterminate">
    </mat-progress-bar> -->
    @if (isTableLoading) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
    @if (!isTableLoading) {
<div>
        @if (!isCustomOverrideWindow) {
<div class="modal-body" style="overflow: scroll;width:100%;">
            <div class="divShadow1">
                    <div class="table table-hover table-bordered table-striped table-condensed" style="border:none;">
                        <ap-table #basicTable [data]="processedTableData" [striped]="true">
                            <table>
        <caption class="sr-only">Schedule C line details</caption>
                            <thead class="a-thead">
                                <tr>
                                    <th>View/Edit</th>
                                    <th>Delete</th>
                                    @for (col of lineColDtls; track $index; let i = $index) {
<th>{{col.COL_DESC}}</th>
}
                                </tr>
                            </thead>
                            <tbody class="a-tbody tbody-regular tbody-hover">
                                    @for (lineWithSno of basicTable.data; track $index; let i = $index) {
<tr>
                                            <td>
                                              <ap-button class = "actioniconssuppl" [compact]="true" [btnType]="'tertiary'"  [disabled]="false" (onClick)="editICalcDelta(lineWithSno)">
                                                    <span class="Appkit4-icon icon-edit-fill"></span>
                                                </ap-button>
                                            </td>
                                            <td>
                                              <ap-button class = "actioniconssuppl" [compact]="true" [btnType]="'tertiary'" (onClick)="deleteData(lineWithSno.SNO)">
                                                    <span class="Appkit4-icon icon-circle-minus-fill"></span>
                                                </ap-button>
                                            </td>
                                            @for (item of lineWithSno.items; track $index; let j = $index) {
<td  class="amountALign">{{item.ELEMENT_VALUE}}</td>
}
                                    </tr>
}
                            </tbody>
                            </table>
                        </ap-table>
                    </div>
        </div>
        </div>
}
    </div>
}

</div>
}
